
export default {
  name: 'RegisterLanding',
  auth: 'guest',
};
